import { type ClientInferRequest } from "@ts-rest/core";

import { type apiContract } from "~/api/contract";

import { client } from "../client";

type GetSchoolsRequest = ClientInferRequest<
  typeof apiContract.v1.pos.schools.get
>;

export async function getSchools(query: GetSchoolsRequest["query"]) {
  const response = await client.v1.pos.schools.get({
    query
  });

  if (response.status === 200) {
    return response.body;
  }

  throw response;
}
